// eslint-disable-next-line import/no-cycle
import { analyticService } from '../services'

export interface AbacusMatrixTag {
    device_id: string
    customer_id: string
    pin_customer_id: string
    action: string
    page: string
    field: string
    useragent: string
    app_version: string
    fis_contract_id: number
    has_EASY: boolean
    hostname: string
}

export interface AbacusMatrixProps {
    name?: string
    value?: string
    tags: Partial<AbacusMatrixTag>
}

export enum TagManagerEvent {
    CLICK_EVENT = 'click',
    LOAD_EVENT = 'load',
    POPUP_EVENT = 'popup',
}

class TagManager {
    private name: string

    private value: string

    private liffVersion: string

    constructor() {
        this.name = 'lending.chatbot.thunder.useraction'
        this.value = '1'
        this.liffVersion = window.liff.getVersion()
    }

    get hostname() {
        return window.location.href
    }

    private sendAnalytic(action: TagManagerEvent) {
        return (tags: Partial<AbacusMatrixProps['tags']>) => {
            analyticService.sendData({
                name: this.name,
                tags: {
                    ...tags,
                    app_version: this.liffVersion,
                    action,
                    hostname: this.hostname,
                },
                value: this.value,
            })
        }
    }

    clickEvent = this.sendAnalytic(TagManagerEvent.CLICK_EVENT)

    loadEvent = this.sendAnalytic(TagManagerEvent.LOAD_EVENT)

    popupEvent = this.sendAnalytic(TagManagerEvent.POPUP_EVENT)
}

const instance = new TagManager()

Object.freeze(instance)
export default instance
